// Constants
import { DRAG_MODIFIER_KEYS_SET } from './dragModifierKeysConstants';

export const setDragModifierKeys = (modifierKeys) => ({
    type: DRAG_MODIFIER_KEYS_SET,
    modifierKeys,
});
